import React from 'react';
import styles from './DesktopCarousel.module.scss';
import image from './gribble-placeholder.png';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { DropdownAnchor } from 'components/Dropdown/Dropdown';
import { GribbleSharing } from 'components/Account/GribbleCollection';
import { Button } from 'components/Button/Button';
import { CarouselProps, GribbleProperties, PositionDots, RevealHeader } from './Summary';
import { GribbleAside } from './GribbleAside';
import cls from 'classnames';
import { GRIBBLE_CONTRACT_ADDRESS } from 'utils/contract';
import { m } from 'framer-motion';

export const DesktopCarousel = ({
  currentGribble,
  gribbleCount,
  index,
  first,
  last,
  next,
  prev,
  stage,
  revealAll,
  revealOne,
  finish,
  currentStageRevealed,
}: CarouselProps) => {
  const isRevealing = stage === 'colors' || stage === 'properties';
  return (
    <m.div
      initial={{ translateX: 200 }}
      animate={{ translateX: 0 }}
      transition={{ ease: 'easeOut', duration: 0.5 }}
    >
      <div className={styles.gribbleSummaryContainer}>
        <GribbleAside currentGribble={currentGribble} image={image} />
        <div className={styles.gribbleSummaryRight}>
          {isRevealing && (
            <div className={styles.revealHeader}>
              <RevealHeader stage={stage} />
            </div>
          )}
          <div className={styles.top}>
            <div className={cls(styles.properties, { [styles.revealing]: isRevealing })}>
              <GribbleProperties
                isRevealing={isRevealing}
                currentGribble={currentGribble}
                revealOne={revealOne}
                stage={stage}
              />
            </div>
          </div>
          <HorizontalDivider className={styles.horizontalDivider} />
          <div className={cls(styles.bottom, { [styles.revealingButtons]: isRevealing })}>
            {isRevealing ? (
              <>
                <Button
                  small
                  className={styles.revealingButton}
                  onClick={revealAll}
                  disabled={currentStageRevealed}
                >
                  Reveal All
                </Button>
                <Button
                  small
                  primary
                  className={styles.revealingButton}
                  onClick={next}
                  disabled={!currentStageRevealed}
                >
                  Next
                </Button>
              </>
            ) : (
              <>
                <PositionDots index={index} gribbleCount={gribbleCount} />
                <div className={styles.controls}>
                  <DropdownAnchor>
                    <GribbleSharing
                      gribble={{
                        nftId: Number(currentGribble.id),
                        contract: GRIBBLE_CONTRACT_ADDRESS,
                      }}
                    />
                  </DropdownAnchor>
                  <div className={styles.verticalDivider}></div>
                  {gribbleCount > 1 && (
                    <Button small onClick={prev} disabled={first}>
                      Previous
                    </Button>
                  )}
                  <Button
                    small
                    primary
                    onClick={last ? finish : next}
                    disabled={!currentStageRevealed && !last && gribbleCount === 1}
                  >
                    {last ? 'Finish' : 'Next'}
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </m.div>
  );
};
